import { GrammarCheckAlert } from '../types';

interface CachedResult {
  alerts: GrammarCheckAlert[];
  timestamp: number;
}

export class GrammarCheckCache {
  private cache: Map<string, CachedResult> = new Map();

  public get(sentence: string): GrammarCheckAlert[] | null {
    const cached = this.cache.get(sentence);
    if (!cached) return null;
    return cached.alerts;
  }

  public set(sentence: string, alerts: GrammarCheckAlert[]): void {
    this.cache.set(sentence, {
      alerts,
      timestamp: Date.now(),
    });
  }

  public clear(): void {
    this.cache.clear();
  }
}
